import * as React from 'react';
import { FC, useContext } from 'react';
import { style } from 'typestyle';
import { StoreContext } from '../../../services/store';
import {
  videoZIndex,
  pillBackgroundColor,
  pillFontColor,
  pillActiveBackgroundColor,
} from '../../consts';
import ShoppingBag from '../../Icons/ShoppingBag';
import { onKeyDownEventCallback } from '../../../utils/onKeyDown';

interface ShopButtonProps {
  onClick: () => void;
}

const ShopButton: FC<ShopButtonProps> = ({ onClick }) => {
  const context = useContext(StoreContext);
  const { config, data } = context;

  const label = data.settings?.shop_this_look_text
    ?? config.shopThisLookText
    ?? 'SHOP THIS LOOK';

  return (
    <div className={styles.container}>
      <button
        className={`${styles.pillButton} ${styles.baseButton} ${styles.shopButton}`}
        onClick={onClick}
        onKeyDown={(e) => onKeyDownEventCallback(e, onClick)}
        aria-label="Show products"
      >
        {label}
        {' '}
        <ShoppingBag color="white" size={20} />
      </button>
    </div>
  );
};

export default ShopButton;

const styles = {
  container: style({
    position: 'absolute',
    bottom: 20,
    left: '50%',
    transform: 'translateX(-50%)',
    width: '90%',
    zIndex: videoZIndex + 1,
    display: 'flex',
    justifyContent: 'center',
  }),

  baseButton: style({
    backgroundColor: pillBackgroundColor,
    backdropFilter: 'blur(3px)',
    '-webkit-backdrop-filter': 'blur(3px)',
    color: pillFontColor,
    border: 'none',
    cursor: 'pointer',
    outline: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    $nest: {
      '&:active': {
        backgroundColor: pillActiveBackgroundColor,
      },
      '&:focus-visible': {
        outline: '2px solid white',
        outlineOffset: '2px',
      },
    },
  }),

  pillButton: style({
    padding: '10px 12px',
    borderRadius: '99px',
    fontSize: '14px',
    fontFamily: "'Fustat', sans-serif",
    fontWeight: 300,
    border: `1px solid ${pillFontColor}`,
  }),

  shopButton: style({
    width: '100%',
    justifyContent: 'center',
    gap: '8px',
  }),
};
